<template>
  <div
    style="
      background-color: none;
      width: 620px;
      height: 527.594px;
      position: absolute;
      right: -125px;
      bottom: -124.594px;
    "
  >
    <div
      style="
        position: absolute;
        left: 91.75px;
        width: 72.186px;
        height: 71.205px;
        flex-shrink: 0;
        fill: var(--Theme-Content-c-pink, #ea1662);
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="73"
        height="72"
        viewBox="0 0 73 72"
        fill="none"
      >
        <path
          d="M36.8434 71.2051C56.777 71.2051 72.9364 55.2653 72.9364 35.6025C72.9364 15.9398 56.777 0 36.8434 0C16.9099 0 0.750488 15.9398 0.750488 35.6025C0.750488 55.2653 16.9099 71.2051 36.8434 71.2051Z"
          fill="#EA1662"
        />
      </svg>
    </div>

    <div
      style="
        position: absolute;
        left: 180.75px;
        width: 72.186px;
        height: 71.205px;
        flex-shrink: 0;
        fill: var(--Theme-Content-c-pink, #ea1662);
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="73"
        height="72"
        viewBox="0 0 73 72"
        fill="none"
      >
        <path
          d="M36.8434 71.2051C56.777 71.2051 72.9364 55.2653 72.9364 35.6025C72.9364 15.9398 56.777 0 36.8434 0C16.9099 0 0.750488 15.9398 0.750488 35.6025C0.750488 55.2653 16.9099 71.2051 36.8434 71.2051Z"
          fill="#EA1662"
        />
      </svg>
    </div>

    <div
      style="
        position: absolute;
        left: 364px;
        width: 72.186px;
        height: 71.205px;
        flex-shrink: 0;
        fill: var(--Theme-Content-c-pink, #ea1662);
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="73"
        height="72"
        viewBox="0 0 73 72"
        fill="none"
      >
        <path
          d="M36.8434 71.2051C56.777 71.2051 72.9364 55.2653 72.9364 35.6025C72.9364 15.9398 56.777 0 36.8434 0C16.9099 0 0.750488 15.9398 0.750488 35.6025C0.750488 55.2653 16.9099 71.2051 36.8434 71.2051Z"
          fill="#EA1662"
        />
      </svg>
    </div>

    <div
      style="
        position: absolute;
        left: 457px;
        width: 72.186px;
        height: 71.205px;
        flex-shrink: 0;
        fill: #000;
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="73"
        height="73"
        viewBox="0 0 73 73"
        fill="none"
      >
        <path
          d="M36.3649 72.1173C56.2985 72.1173 72.4579 56.1775 72.4579 36.5148C72.4579 16.852 56.2985 0.912231 36.3649 0.912231C16.4313 0.912231 0.271973 16.852 0.271973 36.5148C0.271973 56.1775 16.4313 72.1173 36.3649 72.1173Z"
          fill="black"
        />
      </svg>
    </div>

    <div
      style="
        position: absolute;
        left: 0;
        top: 95px;
        width: 72.186px;
        height: 71.205px;
        flex-shrink: 0;
        fill: var(--Theme-Content-c-pink, #ea1662);
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="73"
        height="72"
        viewBox="0 0 73 72"
        fill="none"
      >
        <path
          d="M36.8434 71.2051C56.777 71.2051 72.9364 55.2653 72.9364 35.6025C72.9364 15.9398 56.777 0 36.8434 0C16.9099 0 0.750488 15.9398 0.750488 35.6025C0.750488 55.2653 16.9099 71.2051 36.8434 71.2051Z"
          fill="#EA1662"
        />
      </svg>
    </div>

    <div
      style="
        position: absolute;
        left: 91.75px;
        top: 95px;
        width: 72.186px;
        height: 71.205px;
        flex-shrink: 0;
        fill: var(--Theme-Content-c-pink, #ea1662);
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="73"
        height="72"
        viewBox="0 0 73 72"
        fill="none"
      >
        <path
          d="M36.8434 71.2051C56.777 71.2051 72.9364 55.2653 72.9364 35.6025C72.9364 15.9398 56.777 0 36.8434 0C16.9099 0 0.750488 15.9398 0.750488 35.6025C0.750488 55.2653 16.9099 71.2051 36.8434 71.2051Z"
          fill="#EA1662"
        />
      </svg>
    </div>

    <div
      style="
        position: absolute;
        left: 180.75px;
        top: 95px;
        width: 72.186px;
        height: 71.205px;
        flex-shrink: 0;
        fill: var(--Theme-Content-c-pink, #ea1662);
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="73"
        height="72"
        viewBox="0 0 73 72"
        fill="none"
      >
        <path
          d="M36.8434 71.2051C56.777 71.2051 72.9364 55.2653 72.9364 35.6025C72.9364 15.9398 56.777 0 36.8434 0C16.9099 0 0.750488 15.9398 0.750488 35.6025C0.750488 55.2653 16.9099 71.2051 36.8434 71.2051Z"
          fill="#EA1662"
        />
      </svg>
    </div>

    <div
      style="
        position: absolute;
        left: 272.5px;
        top: 95px;
        width: 72.186px;
        height: 71.205px;
        flex-shrink: 0;
        fill: var(--Theme-Content-c-pink, #ea1662);
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="73"
        height="72"
        viewBox="0 0 73 72"
        fill="none"
      >
        <path
          d="M36.8434 71.2051C56.777 71.2051 72.9364 55.2653 72.9364 35.6025C72.9364 15.9398 56.777 0 36.8434 0C16.9099 0 0.750488 15.9398 0.750488 35.6025C0.750488 55.2653 16.9099 71.2051 36.8434 71.2051Z"
          fill="#EA1662"
        />
      </svg>
    </div>

    <div
      style="
        position: absolute;
        left: 364.27px;
        top: 95px;
        width: 72.186px;
        height: 71.205px;
        flex-shrink: 0;
        fill: #000;
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="73"
        height="73"
        viewBox="0 0 73 73"
        fill="none"
      >
        <path
          d="M36.3649 72.1173C56.2985 72.1173 72.4579 56.1775 72.4579 36.5148C72.4579 16.852 56.2985 0.912231 36.3649 0.912231C16.4313 0.912231 0.271973 16.852 0.271973 36.5148C0.271973 56.1775 16.4313 72.1173 36.3649 72.1173Z"
          fill="black"
        />
      </svg>
    </div>

    <div
      style="
        position: absolute;
        left: 457px;
        top: 95px;
        width: 72.186px;
        height: 71.205px;
        flex-shrink: 0;
        fill: #000;
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="73"
        height="73"
        viewBox="0 0 73 73"
        fill="none"
      >
        <path
          d="M36.3649 72.1173C56.2985 72.1173 72.4579 56.1775 72.4579 36.5148C72.4579 16.852 56.2985 0.912231 36.3649 0.912231C16.4313 0.912231 0.271973 16.852 0.271973 36.5148C0.271973 56.1775 16.4313 72.1173 36.3649 72.1173Z"
          fill="black"
        />
      </svg>
    </div>

    <div
      style="
        position: absolute;
        left: 0;
        top: 185.41px;
        width: 72.186px;
        height: 71.205px;
        flex-shrink: 0;
        fill: var(--Theme-Content-c-pink, #ea1662);
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="73"
        height="72"
        viewBox="0 0 73 72"
        fill="none"
      >
        <path
          d="M36.8434 71.2051C56.777 71.2051 72.9364 55.2653 72.9364 35.6025C72.9364 15.9398 56.777 0 36.8434 0C16.9099 0 0.750488 15.9398 0.750488 35.6025C0.750488 55.2653 16.9099 71.2051 36.8434 71.2051Z"
          fill="#EA1662"
        />
      </svg>
    </div>

    <div
      style="
        position: absolute;
        left: 91.75px;
        top: 185.41px;
        width: 72.186px;
        height: 71.205px;
        flex-shrink: 0;
        fill: var(--Theme-Content-c-pink, #ea1662);
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="73"
        height="72"
        viewBox="0 0 73 72"
        fill="none"
      >
        <path
          d="M36.8434 71.2051C56.777 71.2051 72.9364 55.2653 72.9364 35.6025C72.9364 15.9398 56.777 0 36.8434 0C16.9099 0 0.750488 15.9398 0.750488 35.6025C0.750488 55.2653 16.9099 71.2051 36.8434 71.2051Z"
          fill="#EA1662"
        />
      </svg>
    </div>

    <div
      style="
        position: absolute;
        left: 180.75px;
        top: 185.41px;
        width: 72.186px;
        height: 71.205px;
        flex-shrink: 0;
        fill: var(--Theme-Content-c-pink, #ea1662);
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="73"
        height="72"
        viewBox="0 0 73 72"
        fill="none"
      >
        <path
          d="M36.8434 71.2051C56.777 71.2051 72.9364 55.2653 72.9364 35.6025C72.9364 15.9398 56.777 0 36.8434 0C16.9099 0 0.750488 15.9398 0.750488 35.6025C0.750488 55.2653 16.9099 71.2051 36.8434 71.2051Z"
          fill="#EA1662"
        />
      </svg>
    </div>

    <div
      style="
        position: absolute;
        left: 272.5px;
        top: 185.41px;
        width: 72.186px;
        height: 71.205px;
        flex-shrink: 0;
        fill: var(--Theme-Content-c-pink, #ea1662);
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="73"
        height="72"
        viewBox="0 0 73 72"
        fill="none"
      >
        <path
          d="M36.8434 71.2051C56.777 71.2051 72.9364 55.2653 72.9364 35.6025C72.9364 15.9398 56.777 0 36.8434 0C16.9099 0 0.750488 15.9398 0.750488 35.6025C0.750488 55.2653 16.9099 71.2051 36.8434 71.2051Z"
          fill="#EA1662"
        />
      </svg>
    </div>

    <div
      style="
        position: absolute;
        left: 364.27px;
        top: 185.41px;
        width: 72.186px;
        height: 71.205px;
        flex-shrink: 0;
        fill: var(--Theme-Content-c-pink, #ea1662);
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="73"
        height="72"
        viewBox="0 0 73 72"
        fill="none"
      >
        <path
          d="M36.8434 71.2051C56.777 71.2051 72.9364 55.2653 72.9364 35.6025C72.9364 15.9398 56.777 0 36.8434 0C16.9099 0 0.750488 15.9398 0.750488 35.6025C0.750488 55.2653 16.9099 71.2051 36.8434 71.2051Z"
          fill="#EA1662"
        />
      </svg>
    </div>

    <div
      style="
        position: absolute;
        left: 457px;
        top: 185.41px;
        width: 72.186px;
        height: 71.205px;
        flex-shrink: 0;
        fill: #000;
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="73"
        height="73"
        viewBox="0 0 73 73"
        fill="none"
      >
        <path
          d="M36.3649 72.1173C56.2985 72.1173 72.4579 56.1775 72.4579 36.5148C72.4579 16.852 56.2985 0.912231 36.3649 0.912231C16.4313 0.912231 0.271973 16.852 0.271973 36.5148C0.271973 56.1775 16.4313 72.1173 36.3649 72.1173Z"
          fill="black"
        />
      </svg>
    </div>

    <div
      style="
        position: absolute;
        left: 91.75px;
        top: 280.32px;
        width: 72.186px;
        height: 71.205px;
        flex-shrink: 0;
        fill: var(--Theme-Content-c-pink, #ea1662);
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="73"
        height="72"
        viewBox="0 0 73 72"
        fill="none"
      >
        <path
          d="M36.8434 71.2051C56.777 71.2051 72.9364 55.2653 72.9364 35.6025C72.9364 15.9398 56.777 0 36.8434 0C16.9099 0 0.750488 15.9398 0.750488 35.6025C0.750488 55.2653 16.9099 71.2051 36.8434 71.2051Z"
          fill="#EA1662"
        />
      </svg>
    </div>

    <div
      style="
        position: absolute;
        left: 180.75px;
        top: 280.32px;
        width: 72.186px;
        height: 71.205px;
        flex-shrink: 0;
        fill: var(--Theme-Content-c-pink, #ea1662);
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="73"
        height="72"
        viewBox="0 0 73 72"
        fill="none"
      >
        <path
          d="M36.8434 71.2051C56.777 71.2051 72.9364 55.2653 72.9364 35.6025C72.9364 15.9398 56.777 0 36.8434 0C16.9099 0 0.750488 15.9398 0.750488 35.6025C0.750488 55.2653 16.9099 71.2051 36.8434 71.2051Z"
          fill="#EA1662"
        />
      </svg>
    </div>

    <div
      style="
        position: absolute;
        left: 272.5px;
        top: 280.32px;
        width: 72.186px;
        height: 71.205px;
        flex-shrink: 0;
        fill: var(--Theme-Content-c-pink, #ea1662);
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="73"
        height="72"
        viewBox="0 0 73 72"
        fill="none"
      >
        <path
          d="M36.8434 71.2051C56.777 71.2051 72.9364 55.2653 72.9364 35.6025C72.9364 15.9398 56.777 0 36.8434 0C16.9099 0 0.750488 15.9398 0.750488 35.6025C0.750488 55.2653 16.9099 71.2051 36.8434 71.2051Z"
          fill="#EA1662"
        />
      </svg>
    </div>

    <div
      style="
        position: absolute;
        left: 364.27px;
        top: 280.32px;
        width: 72.186px;
        height: 71.205px;
        flex-shrink: 0;
        fill: var(--Theme-Content-c-pink, #ea1662);
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="73"
        height="72"
        viewBox="0 0 73 72"
        fill="none"
      >
        <path
          d="M36.8434 71.2051C56.777 71.2051 72.9364 55.2653 72.9364 35.6025C72.9364 15.9398 56.777 0 36.8434 0C16.9099 0 0.750488 15.9398 0.750488 35.6025C0.750488 55.2653 16.9099 71.2051 36.8434 71.2051Z"
          fill="#EA1662"
        />
      </svg>
    </div>

    <div
      style="
        position: absolute;
        left: 457px;
        top: 280.32px;
        width: 72.186px;
        height: 71.205px;
        flex-shrink: 0;
        fill: var(--Theme-Content-c-pink, #ea1662);
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="73"
        height="72"
        viewBox="0 0 73 72"
        fill="none"
      >
        <path
          d="M36.8434 71.2051C56.777 71.2051 72.9364 55.2653 72.9364 35.6025C72.9364 15.9398 56.777 0 36.8434 0C16.9099 0 0.750488 15.9398 0.750488 35.6025C0.750488 55.2653 16.9099 71.2051 36.8434 71.2051Z"
          fill="#EA1662"
        />
      </svg>
    </div>

    <div
      style="
        position: absolute;
        left: 180.75px;
        top: 364.74px;
        width: 72.186px;
        height: 71.205px;
        flex-shrink: 0;
        fill: var(--Theme-Content-c-pink, #ea1662);
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="73"
        height="72"
        viewBox="0 0 73 72"
        fill="none"
      >
        <path
          d="M36.8434 71.2051C56.777 71.2051 72.9364 55.2653 72.9364 35.6025C72.9364 15.9398 56.777 0 36.8434 0C16.9099 0 0.750488 15.9398 0.750488 35.6025C0.750488 55.2653 16.9099 71.2051 36.8434 71.2051Z"
          fill="#EA1662"
        />
      </svg>
    </div>

    <div
      style="
        position: absolute;
        left: 272.5px;
        top: 364.74px;
        width: 72.186px;
        height: 71.205px;
        flex-shrink: 0;
        fill: var(--Theme-Content-c-pink, #ea1662);
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="73"
        height="72"
        viewBox="0 0 73 72"
        fill="none"
      >
        <path
          d="M36.8434 71.2051C56.777 71.2051 72.9364 55.2653 72.9364 35.6025C72.9364 15.9398 56.777 0 36.8434 0C16.9099 0 0.750488 15.9398 0.750488 35.6025C0.750488 55.2653 16.9099 71.2051 36.8434 71.2051Z"
          fill="#EA1662"
        />
      </svg>
    </div>

    <div
      style="
        position: absolute;
        left: 364.27px;
        top: 364.74px;
        width: 72.186px;
        height: 71.205px;
        flex-shrink: 0;
        fill: var(--Theme-Content-c-pink, #ea1662);
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="73"
        height="72"
        viewBox="0 0 73 72"
        fill="none"
      >
        <path
          d="M36.8434 71.2051C56.777 71.2051 72.9364 55.2653 72.9364 35.6025C72.9364 15.9398 56.777 0 36.8434 0C16.9099 0 0.750488 15.9398 0.750488 35.6025C0.750488 55.2653 16.9099 71.2051 36.8434 71.2051Z"
          fill="#EA1662"
        />
      </svg>
    </div>

    <div
      style="
        position: absolute;
        left: 272px;
        top: 456px;
        width: 72.186px;
        height: 71.205px;
        flex-shrink: 0;
        fill: var(--Theme-Content-c-pink, #ea1662);
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="73"
        height="72"
        viewBox="0 0 73 72"
        fill="none"
      >
        <path
          d="M36.8434 71.2051C56.777 71.2051 72.9364 55.2653 72.9364 35.6025C72.9364 15.9398 56.777 0 36.8434 0C16.9099 0 0.750488 15.9398 0.750488 35.6025C0.750488 55.2653 16.9099 71.2051 36.8434 71.2051Z"
          fill="#EA1662"
        />
      </svg>
    </div>
  </div>
</template>
